import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import PromoBanner from '../components/PromoBanner';

const CookiesPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <PromoBanner />
      <Navigation />
      
      {/* Header */}
      <section className="pt-24 pb-20 bg-white">
        <div className="container">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="heading-large text-gray-900 mb-6">
              Cookie Policy
            </h1>
            <p className="body-large text-gray-600">
              Last updated: January 2025
            </p>
          </div>
        </div>
      </section>

      {/* Cookie Policy Content */}
      <section className="py-20 bg-white">
        <div className="container">
          <div className="max-w-4xl mx-auto prose prose-lg">
            <div className="space-y-8">
              <div>
                <h2 className="heading-medium text-gray-900 mb-4">What Are Cookies</h2>
                <p className="body-standard text-gray-600 mb-6">
                  Cookies are small text files that are stored on your computer or mobile device when you visit a website. 
                  They help us provide you with a better experience and allow certain features to work.
                </p>
              </div>

              <div>
                <h2 className="heading-medium text-gray-900 mb-4">How We Use Cookies</h2>
                <p className="body-standard text-gray-600 mb-4">
                  Zero To Cloud uses cookies to:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>Remember your preferences and settings</li>
                  <li>Analyze site traffic and usage patterns</li>
                  <li>Improve our website performance</li>
                  <li>Provide personalized content and advertisements</li>
                </ul>
              </div>

              <div>
                <h2 className="heading-medium text-gray-900 mb-4">Types of Cookies We Use</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Essential Cookies</h3>
                    <p className="body-standard text-gray-600">
                      These cookies are necessary for the website to function properly and cannot be disabled.
                    </p>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Analytics Cookies</h3>
                    <p className="body-standard text-gray-600">
                      These cookies help us understand how visitors interact with our website by collecting anonymous information.
                    </p>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Marketing Cookies</h3>
                    <p className="body-standard text-gray-600">
                      These cookies track your browsing habits to enable us to show advertising which is more likely to be of interest to you.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="heading-medium text-gray-900 mb-4">Managing Cookies</h2>
                <p className="body-standard text-gray-600 mb-4">
                  You can control and manage cookies in various ways:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>Browser settings: Most browsers allow you to block or delete cookies</li>
                  <li>Opt-out tools: Use industry opt-out tools for advertising cookies</li>
                  <li>Privacy settings: Adjust your privacy settings on our website</li>
                </ul>
              </div>

              <div>
                <h2 className="heading-medium text-gray-900 mb-4">Contact Us</h2>
                <p className="body-standard text-gray-600">
                  If you have any questions about our Cookie Policy, please contact us at{' '}
                  <a href="mailto:hello@techwithlucy.com" className="text-blue-600 hover:text-blue-700">
                    hello@techwithlucy.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default CookiesPage;